import { Account } from '../models/account';

export const featureKey = 'pl-accounts';

export type AccountsState = 'init' | 'pending' | 'success' | 'error';

export interface PLAccountsState {
  account?: Account;
  accountsState?: AccountsState;
}
